import {useState} from 'react'

function FAQItem({question, answer}) {
    const [shown, setShown] = useState(false)

  return (
    <li>
        <span style={{ borderBottom: !shown ? 'solid 1px #d3d3d3': 'none'}} onClick={() => {setShown(!shown)}}>
            <h4>{question}</h4>
            <span>
                {shown ? <i className="fa-solid fa-angle-up"></i> :
                <i className="fa-solid fa-angle-down"></i>}
            </span>
        </span>
        <p style={{display: !shown ? 'none': '', width: '100%', borderBottom: 'solid 1px #d3d3d3'}}>{answer}</p>
    </li>
  )
}

FAQItem.defaultProps = {
    question: 'What is Medbolt all about?',
    answer: "Medbolt is an AI powered EMR. \n ppphhhhhhhhhhhhhhhhhhhhhhhhhhggccccccccccccxxxxxxxxx"
}

export default FAQItem